import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=6db841da"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports